/* global window */
import React, { Component } from 'react';
import { connect } from 'react-redux';

class AddressPart extends Component {


toTitleCase = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : null)


  renderDeliveryAddress(userData) {
    if (!userData) return null;
    const deliveryAddress = userData.addresses.find(a => a.type.toLowerCase() === 'delivery');
    if (!deliveryAddress) return null;

    return (
      <div className="delivery__details u-padding-small u-pale-grey-bg pink-border">
        <div className=""><strong>Delivery address:</strong></div>
        {userData.firstName ? <div>{`${this.toTitleCase(userData.title) || ''} ${(this.toTitleCase(userData.firstName) || '')} ${(this.toTitleCase(userData.surname) || '')}`}</div> : null}
        {deliveryAddress.line1 ? <div>{(this.toTitleCase(deliveryAddress.line1) || '')}</div> : null}
        {deliveryAddress.line2 ? <div>{(this.toTitleCase(deliveryAddress.line2) || '')}</div> : null}
        {deliveryAddress.line3 ? <div>{this.toTitleCase(deliveryAddress.line3)}</div> : null}
        {deliveryAddress.line4 ? <div>{this.toTitleCase(deliveryAddress.line4)}</div> : null}
        {deliveryAddress.postCode ? <div>{this.toTitleCase(deliveryAddress.postCode)}</div> : null}
      </div>
    );
  }

  render() {
    const userData = this.props.user.data;;

    return (
      <div>
        {this.renderDeliveryAddress(userData)}
      </div>
    );
  }  

}

const mapStateToProps = state => ({
  user: state.user,
  isSofologist: state.sofologist.Authorized
});

export default connect(mapStateToProps)(AddressPart);




// WEBPACK FOOTER //
// ./src/cards/templates/DetailsConfirmCard/addressPart.js